import React, {useEffect, useRef, useState} from 'react';
import '@fortawesome/fontawesome-svg-core/styles.css'
import Header from "./Header";
import {serverHttpLinkString} from "../../config";
import {useDispatch} from "react-redux";
import {decodeJWTToken, setIsLoggedIn, setUser} from "../../store/actions/UserActions";
import {jwtDecode} from "jwt-decode";
import {kickUsername} from '../../config';
import Footer from "./Footer";

import Draggable from "react-draggable";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faUpDownLeftRight, faMinimize, faMaximize} from "@fortawesome/free-solid-svg-icons";

const Body = props => {
    const dispatch = useDispatch();
    const [showMiniplayer, setShowMiniplayer] = useState(true);
    const miniPlayerRef = useRef(null)

    const handleEventListener = event => {
        const {token, ok, auth} = event.data;

        if (ok) {
            localStorage.setItem("jwtToken", token);
            const decodedToken = jwtDecode(token);
            dispatch(decodeJWTToken(token));
            dispatch(setUser(decodedToken.user));
            dispatch(setIsLoggedIn(true));
        }
    }

    const toggleMiniplayer = () => {
        setShowMiniplayer(!showMiniplayer);
    }

    useEffect(() => {
        fetch(`https://kick.com/api/v1/channels/${kickUsername}`)
            .then((response) => response.json())
            .then((data) => {
                if(data.livestream){
                    setShowMiniplayer(true);
                }else{
                    setShowMiniplayer(false);
                }
            });
    }, []);

    useEffect(() => {
        window.addEventListener("message", event => {
            if (event.origin != `${serverHttpLinkString}`) return;

            handleEventListener(event);
        });
    }, []);

    return (
        <>
            <div className="content">
                <Header/>
                {props?.children}
                <Draggable handle=".handle" defaultClassName={"hiddenMobile"} nodeRef={miniPlayerRef}>
                    <div className={`draggableWrapper ${showMiniplayer?'shown':'hidden'}`} ref={miniPlayerRef}>
                        {showMiniplayer && <div className="handle"><FontAwesomeIcon icon={faUpDownLeftRight} /></div>}
                        <div className="close" onClick={toggleMiniplayer}>{showMiniplayer ? <FontAwesomeIcon icon={faMinimize} /> : <FontAwesomeIcon icon={faMaximize} />}</div>
                        {showMiniplayer && <div>
                            <iframe src={`https://player.kick.com/${kickUsername}`} frameBorder="0" width="375" height="211"></iframe>
                        </div>}
                    </div>
                </Draggable>
            </div>

            <Footer />
        </>
    )
};

export default Body;
